import axios from "axios";
import Endpoints from "../endpoints/Endpoints.api";
import { ManagerService } from "./Manager.service";
import { normalizeApiError } from "./errorNormalizer";

// Settings
const apiConfig = {
  baseURL: process.env.REACT_APP_BASE_URL,
};

// Client
const API = (access) => {
  var headers = {
    "Content-Type": "application/json",
    // 'ngrok-skip-browser-warning': 'pippo',
  };

  if (access) {
    headers["Authorization"] = "Bearer " + access;
  }

  const instance = axios.create({
    baseURL: apiConfig.baseURL,
    headers: headers,
  });
  instance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalConfig = err.config;

      if (
        originalConfig.url !== Endpoints.auth.login &&
        err.response &&
        originalConfig.url !== Endpoints.auth.refresh
      ) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          const refresh = ManagerService.getToken().refresh;

          try {
            instance
              .post(Endpoints.auth.refresh, { refresh })
              .then((response) => {
                ManagerService.setToken(response.data);
                window.location.reload(false);
              });

            return instance(originalConfig);
          } catch (_error) {
            return Promise.reject(normalizeApiError(_error));
          }
        }
      }

      return Promise.reject(normalizeApiError(err));
    },
  );

  return instance;
};

const Manager = {
  apiConfig: apiConfig,
  client: (access) => API(access),
};

export default Manager;
